// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"538dec42","453":"366801d8"}[chunkId] + ".chunk.js";
};